import factory from '../requestFactory';

export default async() => {
    return factory()
        .get('/clinics');
}
